import React, { useEffect, useRef, useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";
import { getAccessToken } from "../../utils/authTokenStore";  

export default function HeroText() {  
  const buttonRef = useRef(null);
  const [showStickyButton, setShowStickyButton] = useState(false);
  const [visible, setVisible] = useState(false);
  const isLoggedIn = !!getAccessToken();

  useEffect(() => {
    let timeout;

    const handleScroll = () => { 
      if (!buttonRef.current) return;

      const buttonTop = buttonRef.current.getBoundingClientRect().top;

      if (buttonTop < 0) {
        setVisible(true);
        setShowStickyButton(true);

        clearTimeout(timeout);
        timeout = setTimeout(() => {
          setVisible(false);
          setTimeout(() => {
            setShowStickyButton(false);
          }, 500); 
        }, 2000);
      } else {
        setVisible(false);
        setShowStickyButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="text-center text-white z-10 animate-fade-in px-4 relative">
      <h1 className="text-3xl md:text-5xl font-extrabold font-manrope leading-snug drop-shadow-[2px_2px_2px_rgba(0,0,0,0.7)]">
        Achieve Your Fitness Goals with{" "}
        <span className="inline-block min-w-[160px] text-green-400 bg-gradient-to-r from-green-400 via-lime-400 to-green-500 bg-clip-text text-transparent drop-shadow-[1px_1px_2px_rgba(0,0,0,0.8)]">
          <Typewriter
            words={["FitTrack", "DISCIPLINE", "STRENTH","YOGA"]}
            loop={true}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </span>
      </h1>

      <p className="mt-6 max-w-2xl mx-auto text-sm md:text-lg font-manrope leading-relaxed tracking-wide text-gray-200 drop-shadow-[1px_1px_1px_rgba(0,0,0,0.8)] border border-white/20 rounded-md px-4 py-2 bg-white/5 backdrop-blur-sm">
        Your personalized{" "}
        <span className="text-green-400 font-semibold">
          health and fitness companion
        </span>
        . Track your progress, stay motivated, and reach your full potential with insights that adapt to you.
      </p>

      {/* Original Button */}
      {!isLoggedIn && ( 
      <div ref={buttonRef}>
        <Link to="/signup">
          <button className="mt-6 bg-[#54D12B] hover:bg-[#43b51f] text-black font-semibold px-8 py-2.5 rounded-full transition duration-300 shadow-md hover:shadow-lg font-manrope text-base md:text-lg">
            Get Started
          </button>
        </Link>
      </div>
      )}

      {/* Sticky Button */}
      {showStickyButton && (
        <div className="fixed top-3 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-500 ease-in-out">
          <Link to="/signup">
            <button
              className={`bg-[#54D12B] text-black font-semibold px-8 py-2.5 rounded-full shadow-lg font-manrope text-base md:text-lg transform transition-all duration-500 ease-in-out
                ${visible ? "opacity-70 scale-100" : "opacity-0 scale-90 pointer-events-none"}`}
            >
              Get Started
            </button>
          </Link>
        </div>
      )}
    </div>
  );
}
